import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Container,
  CardContent,
  Divider,
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Collapse,
  TextField,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import Paper from "@mui/material/Paper";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import Grafana from "./Actions/Grafana";
import StartLab from "./Actions/Startlab";
import StopLab from "./Actions/Stoplab";
import Refresh from "./Actions/Reload";
import NotToDo from "./Actions/NotToDo";
import WarningAlert from "./Alert/WarningAlert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import StopTwoToneIcon from "@mui/icons-material/StopTwoTone";
import PlayArrowTwoToneIcon from "@mui/icons-material/PlayArrowTwoTone";
import moment from "moment";

const ensureAbsoluteUrl = (url) => {
  if (!url) return '#'; // Fallback in case URL is null or undefined
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`;
  }
  return url;
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const Detail = () => {
  const [expandedRow, setExpandedRow] = useState(null);

  const handleExpandRow = (rowName) => {
    if (rowName === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowName);
    }
  };

  function DateTime1(startDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startDate1 = new Date(startDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");

    return startDate3;
  }

  function DateTime2(endDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");
    return endDate3;
  }

  function DateTime3(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);
    return startTime3;
  }

  function DateTime4(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(
      endDate + "T" + endTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    return endTime3;
  }

  function DateTime21(endDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");

    return endDate3;
  }

  const [value, setValue] = React.useState("");

  // const handleChange = (event) => {
  //   setValue(parseInt(event.target.value));
  // };

  // const handleChange = (event) => {
  //   setValue(String(event.target.value));
  // };


  // const handleChange = (event) => {
  //   setValue(parseInt(event.target.value));
  // };

  const handleChange = (event) => {
    setValue(parseInt(event.target.value));
  };

  useEffect(() => {
    setExpandedRow("");
  }, [value])

  const [validerroropen, setValidErrorOpen] = useState(false);

  function timeDiff(endDate, endTime, startDate, startTime, dependsOn, manageLabs) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const nowTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: timezone,
    });

    const endTime1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString(
      "en-GB",
      { timeZone: `${timezone}` }
    );
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);

    const startTime1 = new Date(startDate + "T" + startTime + ":00.000Z").toLocaleString(
      "en-GB",
      { timeZone: `${timezone}` }
    );
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);

    const endTimeMoment = moment(endTime3, "HH:mm");
    const currentTimeMoment = moment(nowTime, "HH:mm");

    const diffInMinutes = endTimeMoment.diff(currentTimeMoment, "minutes");
    let disable = true;

    const labEndDate = moment(endDate).format("DD-MM-YYYY");
    const currentDate = new Date().toISOString().substring(0, 10);

    if (dependsOn === "immediate" || dependsOn === "always") {
      if (DateTime21(currentDate) === labEndDate) {
        if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
          disable = true;
        } else if (diffInMinutes <= 0) {
          disable = true;
        } else {
          disable = false;
        }
      } else {
        if (new Date(currentDate) <= new Date(endDate)) {
          disable = false;
        } else {
          disable = true;
        }
      }
    } else if (dependsOn === "during_training") {
      if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
        disable = true;
        return disable;
      } else if (
        currentTimeMoment.isSameOrAfter(moment(startTime3, "HH:mm")) &&
        currentTimeMoment.isSameOrBefore(moment(endTime3, "HH:mm"))
      ) {
        disable = false;
      } else if (dependsOn === "during_training" && manageLabs === "yes") {
        disable = false;
        return disable;
      } else if (
        dependsOn === "during_training" &&
        manageLabs === "no" &&
        currentTimeMoment.isAfter(moment(endTime3, "HH:mm"))
      ) {
        disable = true;
      }
    }

    return disable;
  }

  const [instancelist, setinstancelist] = useState([]);
  useEffect(() => {
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(
      `${process.env.REACT_APP_API_URL}/api/cloudlabDetailedview/${InstanceID}/trainer`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setinstancelist(data);
          if (data[0]?.popup_status === "no" || data[0]?.popup_status === "") {
            setValidErrorOpen(true);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [openLog, setOpenLog] = React.useState(false);

  const handleClickOpenLog = () => {
    setOpenLog(true);
  };

  const handleCloseLog = () => {
    setOpenLog(false);
  };

  const handleLogOk = () => {
    setOpenLog(false);
  };

  const [opendelete, setOpendelete] = React.useState(false);
  const handleClickOpenDelete = () => {
    setOpendelete(true);
  };

  const [showInstancePassword, setShowInstancePassword] = useState(false);

  const handleInstancePasswordIconClick = () => {
    setShowInstancePassword(!showInstancePassword);
  };

  const handleCloseDelete = () => {
    setOpendelete(false);
  };

  const handleDeleteConfirm = () => {
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(
      `${process.env.REACT_APP_API_URL}/api/manageCloudlabs/${InstanceID}/`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((response) => response.json())
      .catch((error) => {
        console.error("Delete failed", error);
      })
      .finally(() => {
        handleCloseDelete();
        window.location.href = "/app/runninglabs";
      });
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleIconClick = () => {
    setShowPassword(!showPassword);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleCopyClick = async (event, textToCopy) => {
    try {
      if (textToCopy) {
        await navigator.clipboard.writeText(textToCopy);
        setCopied(true);
        setAnchorEl(event.currentTarget);
      }
    } catch (error) {
      console.error("Failed to copy", error);
      setCopied(false);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleCopyClose = () => {
    setAnchorEl(null);
    setCopied(false);
  };

  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;
  const [copied, setCopied] = React.useState(false);
  const instances = Array.isArray(instancelist) ? instancelist : [];

  return (
    <>
      <WarningAlert
        validerroropen={validerroropen}
        setvaliderroropen={setValidErrorOpen}
        alertLabType={"cloud"}
      />
      {instances.map((instancelist) => (
        <React.Fragment key={instancelist.id}>
          <Helmet>
            <title>LabAsService</title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 3,
            }}
          >
            <Dialog
              open={opendelete}
              onClose={handleCloseDelete}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Are you sure you want to delete the Lab{" "}
                <strong style={{ color: "#EF5350" }}>
                  {instancelist.name}
                </strong>{" "}
                ?
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description"></DialogContentText>
              </DialogContent>
              <DialogActions>
                <Tooltip title="Cancel" arrow>
                  <Button
                    onClick={handleCloseDelete}
                    color="primary"
                    sx={{
                      borderRadius: "50px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      px: 3,
                    }}
                  >
                    Cancel
                  </Button>
                </Tooltip>
                <Tooltip title="Confirm Delete" arrow>
                  <Button
                    onClick={handleDeleteConfirm}
                    color="primary"
                    autoFocus
                    sx={{
                      borderRadius: "50px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      px: 3,
                    }}
                  >
                    Delete
                  </Button>
                </Tooltip>
              </DialogActions>
            </Dialog>
            <Dialog
              open={openLog}
              onClose={handleCloseLog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">Activity Log</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Hello
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Tooltip title="Close" arrow>
                  <Button
                    onClick={handleLogOk}
                    color="primary"
                    autoFocus
                    sx={{
                      borderRadius: "50px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      px: 3,
                    }}
                  >
                    Close
                  </Button>
                </Tooltip>
              </DialogActions>
            </Dialog>
            
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 0, pb: 0 }}>
              <NotToDo />
              <Refresh />
              {/* <LabReport
              // name={details.name}
              // index_name={details.tag}
              // analytics_panel_id={details.analytics_panel_id}
              /> */}
              {instancelist.status === "Stopped" ? (
                <StartLab
                  endDate={`${instancelist.end_date}`}
                  endTime={`${instancelist.stop_time}`}
                  startDate={`${instancelist.start_date}`}
                  startTime={`${instancelist.start_time}`}
                  depends_on={instancelist.depends_on}
                  manage_labs={instancelist.manage_labs}
                  labType="cloud"
                  startcron={instancelist.startcron}
                  startcron1={instancelist.startcron1}
                  repeat_frequency={instancelist.repeat_frequency}
                  on_days={instancelist.on_days}
                />
              ) : instancelist.status === "Active" || instancelist.status === "Running" ? (
                <React.Fragment>
                  {/* <ReportEX pccreportdataset={pccreportdataset} /> */}
                  <StopLab
                    endDate={`${instancelist.end_date}`}
                    endTime={`${instancelist.stop_time}`}
                    startDate={`${instancelist.start_date}`}
                    startTime={`${instancelist.start_time}`}
                    depends_on={instancelist.depends_on}
                    manage_labs={instancelist.manage_labs}
                    labType="cloud"
                  />
                </React.Fragment>
              ) : instancelist.status === "Stop Initiated" ? (
                <Tooltip title="Stop Initiated" arrow>
                  <span>
                    <IconButton
                      sx={{
                        mx: 0.5,
                        height: { xs: "26px", sm: "30px" },
                        width: { xs: "26px", sm: "30px" },
                        minWidth: 'auto',
                        p: 0,
                        marginBottom: { xs: "3px", sm: "5px" },
                        marginTop: { xs: "-18px", sm: "-20px" },
                        borderRadius: '12px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        '&.Mui-disabled': {
                          boxShadow: 'none',
                          opacity: 0.5
                        }
                      }}
                      color="primary"
                      disabled={timeDiff(instancelist.end_date, instancelist.stop_time, instancelist.start_date, instancelist.start_time, instancelist.depends_on, instancelist.manage_labs)}
                    >
                      <StopTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : instancelist.status === "Start Initiated" ? (
                <Tooltip title="Start Initiated" arrow>
                  <span>
                    <IconButton
                      sx={{
                        mx: 0.5,
                        height: { xs: "26px", sm: "30px" },
                        width: { xs: "26px", sm: "30px" },
                        minWidth: 'auto',
                        p: 0,
                        marginBottom: { xs: "3px", sm: "5px" },
                        marginTop: { xs: "-18px", sm: "-20px" },
                        borderRadius: '12px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        '&.Mui-disabled': {
                          boxShadow: 'none',
                          opacity: 0.5
                        }
                      }}
                      color="primary"
                      disabled={timeDiff(instancelist.end_date, instancelist.stop_time, instancelist.start_date, instancelist.start_time, instancelist.depends_on, instancelist.manage_labs)}
                    >
                      <PlayArrowTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : instancelist.status === "Stopping" ? (
                <Tooltip title="Stopping" arrow>
                  <span>
                    <IconButton
                      sx={{
                        mx: 0.5,
                        height: { xs: "26px", sm: "30px" },
                        width: { xs: "26px", sm: "30px" },
                        minWidth: 'auto',
                        p: 0,
                        marginBottom: { xs: "3px", sm: "5px" },
                        marginTop: { xs: "-18px", sm: "-20px" },
                        borderRadius: '12px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        '&.Mui-disabled': {
                          boxShadow: 'none',
                          opacity: 0.5
                        }
                      }}
                      color="primary"
                      disabled={timeDiff(instancelist.end_date, instancelist.stop_time, instancelist.start_date, instancelist.start_time, instancelist.depends_on, instancelist.manage_labs)}
                    >
                      <StopTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : instancelist.status === "Starting" ? (
                <Tooltip title="Starting" arrow>
                  <span>
                    <IconButton
                      sx={{
                        mx: 0.5,
                        height: { xs: "26px", sm: "30px" },
                        width: { xs: "26px", sm: "30px" },
                        minWidth: 'auto',
                        p: 0,
                        marginBottom: { xs: "3px", sm: "5px" },
                        marginTop: { xs: "-18px", sm: "-20px" },
                        borderRadius: '12px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        '&.Mui-disabled': {
                          boxShadow: 'none',
                          opacity: 0.5
                        }
                      }}
                      color="primary"
                      disabled={timeDiff(instancelist.end_date, instancelist.stop_time, instancelist.start_date, instancelist.start_time, instancelist.depends_on, instancelist.manage_labs)}
                    >
                      <PlayArrowTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : (
                ""
              )}
              <Tooltip title="Delete" arrow>
                <span>
                  <Button
                    sx={{
                      mx: 0.5,
                      height: { xs: "26px", sm: "30px" },
                      width: { xs: "26px", sm: "30px" },
                      minWidth: "auto",
                      borderRadius: "50px",
                      marginRight: "30px",
                      marginBottom: "20px",
                      marginTop: "-15px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      p: 0,
                    }}
                    variant="contained"
                    color="error"
                    onClick={handleClickOpenDelete}
                    disabled={
                      !(
                        instancelist.status === "Running" ||
                        instancelist.status === "Active" ||
                        instancelist.status === "Stopped" ||
                        instancelist.status === "failed_con_update"
                      )
                      || timeDiff(
                        instancelist.end_date,
                        instancelist.stop_time,
                        instancelist.start_date,
                        instancelist.start_time,
                        instancelist.depends_on,
                        instancelist.manage_labs
                      )
                    }
                    aria-label="delete lab"
                  >
                    <DeleteIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
                  </Button>
                </span>
              </Tooltip>
            </Box>
            
            <Container maxWidth={false}>
              {/* <Box border={0} sx={{ mt: 0 }}> */}
                <Card>
                  <CardContent sx={{ py: 1.5, px: 2 }}>
                    <Box
                      sx={{
                        background: 'linear-gradient(90deg, rgb(6, 57, 108), rgb(6, 57, 108))',
                        borderRadius: '8px',
                        px: 2,
                        py: 0.5,
                        mb: 1,
                        boxShadow: 2,
                      }}
                    >
                      <Typography
                        color="white"
                        display="inline-block"
                        variant="h6"
                        sx={{
                          // lineHeight: 1.1,
                          fontWeight: 500,
                          mb: 0,
                        }}
                      >
                        Lab Name: {instancelist.name}
                      </Typography>
                    </Box>
                    <div>
                      <TableContainer component={Paper}>
                        <Table size="small" aria-label="simple table">
                          <TableBody>
                            <TableRow key="name">
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block", marginBottom: 0 }}
                                >
                                  CodeShare : <Tooltip title="Open CodeShare" arrow>
                                    <Button size="small" style={{ height: "25px" }} variant="outlined" target="_blank" endIcon={<OpenInNewIcon style={{ height: "15px" }} />} href={instancelist.codeshare}>
                                      Open
                                    </Button>
                                  </Tooltip>
                                  <Tooltip title="Copy CodeShare" arrow>
                                    <IconButton
                                      aria-label="copy codeshare"
                                      color="primary"
                                      onClick={(event) => handleCopyClick(event, instancelist.codeshare)}
                                      sx={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon sx={{ height: "20px" }} />
                                    </IconButton>
                                  </Tooltip>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleCopyClose}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        color: "forestgreen",
                                      }}
                                    >
                                      {copied ? "Copied!" : "Copy failed"}
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{
                                    display: "inline-block",
                                    marginBottom: 0,
                                  }}
                                >
                                  Status : <span style={{ fontWeight: "normal" }}>{instancelist.status}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block", marginBottom: 0 }}
                                >
                                  Number of Trainees : <span style={{ fontWeight: "normal" }}>{instancelist.no_of_trainee}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block", marginBottom: 0 }}
                                >Budget : <span style={{ fontWeight: "normal" }}>{`${instancelist.budget_amount}`}</span> </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block", marginBottom: 0 }}
                                >Provider  : <span style={{ fontWeight: "normal" }}>{`${instancelist.provider}`}</span> </Typography>
                              </TableCell>
                            </TableRow>
                            <TableRow key="name">
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block", marginBottom: 0 }}
                                >
                                  Schedule : <span style={{ fontWeight: "normal" }}>{instancelist.depends_on}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block", marginBottom: 0 }}
                                >
                                  Start Date : <span style={{ fontWeight: "normal" }}>{DateTime1(`${instancelist.start_date}`)}</span>
                                </Typography>
                              </TableCell>
                              {instancelist.start_time == "" ||
                                instancelist.start_time == null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block", marginBottom: 0 }}
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block", marginBottom: 0 }}
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>{DateTime3(`${instancelist.start_date}`, `${instancelist.start_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block", marginBottom: 0 }}
                                >
                                  End Date : <span style={{ fontWeight: "normal" }}>{DateTime2(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                </Typography>
                              </TableCell>

                              {instancelist.stop_time == "" ||
                                instancelist.stop_time == null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block", marginBottom: 0 }}
                                  >
                                    End Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block", marginBottom: 0 }}
                                  >
                                    End Time : <span style={{ fontWeight: "normal" }}>{DateTime4(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                            </TableRow>
                            <TableRow key="meetingurl">
                              <TableCell align="left" component="th" scope="row">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block", marginBottom: 0 }}
                                >
                                  Meeting Link:
                                  <a
                                    href={ensureAbsoluteUrl(instancelist.meeting_url)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'underline', color: 'blue', marginLeft: '10px' }}
                                  >
                                    {instancelist.meeting_url}
                                  </a>
                                  <Tooltip title="Copy meeting link" arrow>
                                    <IconButton
                                      aria-label="copy meeting link"
                                      color="primary"
                                      onClick={(event) => handleCopyClick(event, instancelist.meeting_url)}
                                      sx={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon sx={{ height: "20px" }} />
                                    </IconButton>
                                  </Tooltip>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleCopyClose}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography style={{ color: "forestgreen" }}>
                                      {copied ? "Copied!" : "Copy failed"}
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </CardContent>
                </Card>
              {/* </Box> */}
              <Divider />
              
              <Box border={0} sx={{ mt: 0.5 }} paddingBottom={0} paddingTop={0}>
                <Card>
                  <Typography
                    color="textPrimary"
                    variant="h6"
                    style={{ marginLeft: "20px", marginTop: '8px', marginBottom: '4px' }}
                  >
                    Instance Details
                    <Divider sx={{ mt: 0.5 }} />
                  </Typography>
                  <TextField
                    fullWidth
                    name={`trainee_name`}
                    id={`trainee_name`}
                    value={value}
                    onChange={handleChange}
                    required
                    select
                    SelectProps={{
                      native: true,
                      style: {
                        color: '#000000',
                        height: '30px'
                      },
                    }}
                    autoComplete="name"
                    sx={{ width: '400px', mb: 1 }}
                    style={{ color: '#ffffff', marginLeft: '20px', marginTop: '4px' }}
                  >
                    <option value="" style={{ color: '#000000' }}>Select the Trainee</option>
                    {instancelist.details.map((instance_info, i) => (
                      <option key={i} value={i} {...a11yProps(i)} style={{ color: '#000000' }}>
                        {instance_info.name}
                      </option>
                    ))}
                  </TextField>


                  <PerfectScrollbar>
                    <Card>
                      <CardContent sx={{ py: 1, px: 2 }}>
                        {instancelist.details.map((instance_info, i) => {
                          const traineeid = i + 1;
                          return (
                            <React.Fragment>
                              {/* {selectedTrainee === `Trainee-${traineeid}` && ( */}
                              <TabPanel value={value} index={i}>
                                <Grid
                                  container
                                  spacing={0.5}
                                  marginTop={-5}
                                  marginBottom={-0.5}
                                  marginLeft={0}
                                >
                                  <Grid item xs={12} marginLeft={0}>
                                    <Typography
                                      style={{ display: "inline-block", marginBottom: 0 }}
                                    >
                                      Assigned user :
                                    </Typography>
                                    <Typography
                                      fontWeight={500}
                                      marginLeft={1}
                                      style={{ display: "inline-block", marginBottom: 0 }}
                                    >
                                      {instance_info.email}
                                    </Typography>
                                  </Grid>

                                </Grid>
                                <TableContainer component={Paper}>
                                  <Table
                                    size="small"
                                    // style={{ width: 1215 }}
                                    aria-label="a dense table"
                                  >
                                    <TableHead
                                      style={{ backgroundColor: "#06396c", }}
                                    >
                                      <TableRow sx={{ height: '28px' }}>
                                        <TableCell />
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Name
                                        </TableCell>
                                        {/* <TableCell
                                            style={{ color: "#ffffff" }}
                                            align="left"
                                          >
                                            Provider
                                          </TableCell> */}
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Status
                                        </TableCell>
                                        <TableCell
                                          style={{ color: "#ffffff", paddingRight: '10px' }}
                                          align="left"
                                        >
                                          Console Panel
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {instance_info.details.map((details) => (
                                        <React.Fragment key={details.name}>
                                          <TableRow>
                                            <TableCell>
                                              <IconButton
                                                size="small"
                                                onClick={() => handleExpandRow(details.name)}
                                              >
                                                {expandedRow === details.name ? (
                                                  <KeyboardArrowUp />
                                                ) : (
                                                  <KeyboardArrowDown />
                                                )}
                                              </IconButton>
                                            </TableCell>
                                            <TableCell style={{ paddingLeft: '10px' }} align="left">{details.name}</TableCell>
                                            {/* <TableCell style={{ paddingLeft: '30px' }} align="left">{instancelist.provider}</TableCell> */}
                                            <TableCell style={{ paddingLeft: '5px' }} align="left">
                                              {details.status === "Creating" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#2234E8",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status ===
                                                "Running" || details.status === "Active" ||
                                                details.status === "running" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#209508",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stopped" || details.status === "stopped" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Starting" || details.status === "starting" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stopping" || details.status === "stopping" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Start Initiated" || details.status === "start initiated" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stop Initiated" || details.status === "stop initiated" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Create" || details.status === "failed_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Con_Create" || details.status === "failed_con_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Stop" || details.status === "failed_stop" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Start" || details.status === "failed_start" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Con_Update" || details.status === "failed_con_update" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Cordon" || details.status === "failed_cordon" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_add" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_remove" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_add_con_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                    marginBottom: 0,
                                                  }}
                                                  // marginLeft={1}
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : (
                                                "NA"
                                              )}
                                            </TableCell>
                                            <TableCell align="left" colSpan={4}>
                                              <Tooltip title="Connect" arrow>
                                                <Button
                                                  size="small"
                                                  variant="contained"
                                                  target="_blank"
                                                  endIcon={<OpenInNewIcon sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }} />}
                                                  href={instancelist.provider === "Azure" ? "https://portal.azure.com/" : `https://${details.account_id}.signin.aws.amazon.com/console`}
                                                  sx={{
                                                    height: { xs: "26px", sm: "30px" },
                                                    borderRadius: "50px",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                    px: 2,
                                                  }}
                                                  disabled={timeDiff(instancelist.end_date, instancelist.stop_time, instancelist.start_date, instancelist.start_time, instancelist.depends_on, instancelist.manage_labs)}
                                                >
                                                  Connect
                                                </Button>
                                              </Tooltip>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              style={{ paddingBottom: 0, paddingTop: 0 }}
                                              colSpan={4}
                                            >
                                              <Collapse
                                                in={expandedRow === details.name}
                                                timeout="auto"
                                                unmountOnExit
                                              >
                                                <Box sx={{ p: 0.5 }}>
                                                  {/* Content to display when row is expanded - Responsive Card Grid */}
                                                  <Grid container spacing={0.5}>
                                                    {/* Row 1 */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '140px' }}>
                                                          Account Id :
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          <Typography variant="body2">
                                                            {details.account_id || 'NA'}
                                                          </Typography>
                                                          {details.account_id && (
                                                            <Tooltip title="Copy account id" arrow>
                                                              <IconButton
                                                                size="small"
                                                                color="primary"
                                                                onClick={(event) => handleCopyClick(event, details.account_id)}
                                                                sx={{ height: 28, width: 28 }}
                                                              >
                                                                <FileCopyOutlinedIcon sx={{ fontSize: "18px" }} />
                                                              </IconButton>
                                                            </Tooltip>
                                                          )}
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '130px' }}>
                                                          Account Username :
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          <Typography variant="body2">
                                                            {instancelist.provider === "Azure"
                                                              ? details.account_name
                                                              : instance_info.username}
                                                          </Typography>
                                                          <Tooltip title="Copy account username" arrow>
                                                            <IconButton
                                                              size="small"
                                                              color="primary"
                                                              onClick={(event) => handleCopyClick(event, instancelist.provider === "Azure" ? details.account_name : instance_info.username)}
                                                              sx={{ height: 28, width: 28 }}
                                                            >
                                                              <FileCopyOutlinedIcon sx={{ fontSize: "18px" }} />
                                                            </IconButton>
                                                          </Tooltip>
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '130px' }}>
                                                          Account Password:
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          {showPassword ? (
                                                            <Typography variant="body2">{details.instance_password}</Typography>
                                                          ) : (
                                                            <Typography variant="body2">******</Typography>
                                                          )}
                                                          <IconButton size="small" color="primary" onClick={handleIconClick}>
                                                            {showPassword ? <VisibilityOffIcon style={{ fontSize: "18px" }} /> : <VisibilityIcon style={{ fontSize: "18px" }} />}
                                                          </IconButton>
                                                          <Tooltip title="Copy account password" arrow>
                                                            <IconButton
                                                              size="small"
                                                              color="primary"
                                                              onClick={(event) => handleCopyClick(event, details.instance_password)}
                                                              sx={{ height: 28, width: 28 }}
                                                            >
                                                              <FileCopyOutlinedIcon sx={{ fontSize: "18px" }} />
                                                            </IconButton>
                                                          </Tooltip>
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    
                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                    {/* Popover for Copy confirmation */}
                                                    <Popover
                                                      id={id}
                                                      open={open1}
                                                      anchorEl={anchorEl}
                                                      onClose={handleCopyClose}
                                                      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                                      transformOrigin={{ vertical: "top", horizontal: "center" }}
                                                    >
                                                      <Typography style={{ color: "forestgreen", padding: "4px 8px" }}>
                                                        {copied ? "Copied!" : "Copy failed"}
                                                      </Typography>
                                                    </Popover>

                                                    {/* Row 2 */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '120px' }}>
                                                          Account Name:
                                                        </Typography>
                                                        <Typography variant="body2">{details.account_name || 'NA'}</Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={8}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5, flexWrap: 'wrap' }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '110px' }}>
                                                          Console URL:
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                            {instancelist.provider === 'Azure' ? 'https://portal.azure.com/' : instancelist.provider === 'Gcp' ? 'https://console.cloud.google.com/' : `https://${details.account_id}.signin.aws.amazon.com/console`}
                                                          </Typography>
                                                          <Tooltip title="Copy console URL" arrow>
                                                            <IconButton
                                                              size="small"
                                                              color="primary"
                                                              onClick={(event) => handleCopyClick(event, instancelist.provider === 'Azure' ? 'https://portal.azure.com/' : instancelist.provider === 'Gcp' ? 'https://console.cloud.google.com/' : `https://${details.account_id}.signin.aws.amazon.com/console`)}
                                                              sx={{ height: 28, width: 28 }}
                                                            >
                                                              <FileCopyOutlinedIcon sx={{ fontSize: '18px' }} />
                                                            </IconButton>
                                                          </Tooltip>
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                    {/* Row 3 */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '110px' }}>
                                                          Usage Report:
                                                        </Typography>
                                                        <Grafana
                                                          index_name={details.account_id}
                                                          analytics_panel_id={details.analytics_panel_id}
                                                        />
                                                      </Box>
                                                    </Grid>
                                                    {/* <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '100px' }}>
                                                          Activity Log:
                                                        </Typography>
                                                        <Tooltip title="Active Log" arrow>
                                                          <Button
                                                            sx={{
                                                              mx: 0.5,
                                                              height: 25,
                                                              minWidth: 70,
                                                            }}
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={handleClickOpenLog}
                                                          >
                                                            Log
                                                          </Button>
                                                        </Tooltip>
                                                      </Box>
                                                    </Grid> */}
                                                    
                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                  </Grid>
                                                </Box>
                                               
                                              </Collapse>
                                            </TableCell>
                                          </TableRow>
                                        </React.Fragment>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </TabPanel>
                              {/* )} */}
                            </React.Fragment>
                          );
                        })}
                      </CardContent>
                    </Card>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </Container>
          </Box>
        </React.Fragment>
      ))}
    </>
  );
};

export default Detail;
